// extracted by mini-css-extract-plugin
export default {"root":"CarrierCard_root__RYQUI","iconBox":"CarrierCard_iconBox__aGfmN"};